var map = {
	"./articles": 13086,
	"./articles.json": 13086,
	"./articles/AI_Impacts.webp": 97820,
	"./articles/ARM_AMD.jpeg": 7234,
	"./articles/SSD.webp": 95580,
	"./articles/VR_AR.webp": 27688,
	"./articles/cnn.bin": 28936,
	"./articles/cnn.webp": 18331,
	"./articles/edgeai.webp": 73241,
	"./articles/esp8266.webp": 63364,
	"./articles/iot.webp": 67726,
	"./articles/ml_intro.webp": 96442,
	"./articles/neuro.webp": 93097,
	"./articles/photonic.webp": 10388,
	"./articles/quantum.webp": 25223,
	"./articles/rpi.webp": 5883,
	"./data": 32501,
	"./data.json": 32501,
	"./database": 40236,
	"./database.json": 40236,
	"./images/banner.jpg": 56193,
	"./images/comp.jpg": 49122,
	"./images/fabio-oyXis2kALVg-unsplash.jpg": 77063,
	"./images/favicon.ico": 80880,
	"./images/img1.jpg": 62061,
	"./images/img2.jpg": 92834,
	"./images/img3.jpg": 84543,
	"./images/img4.jpg": 6260,
	"./images/img5.jpg": 78065,
	"./images/img6.jpg": 62214,
	"./images/lectures.jpg": 23526,
	"./images/pic01.jpg": 86358,
	"./images/pic02.jpg": 92289,
	"./images/pic03.jpg": 97892,
	"./images/pic04.jpg": 92207,
	"./images/pic05.jpg": 24274,
	"./images/pic06.jpg": 34173,
	"./images/pic07.jpg": 78592,
	"./images/pic08.jpg": 84059,
	"./images/project.jpg": 32280,
	"./images/projects/summer13/3dc.jpg": 10940,
	"./images/projects/summer13/aq.jpg": 76596,
	"./images/projects/summer13/at.jpg": 90701,
	"./images/projects/summer13/au.jpg": 63600,
	"./images/projects/summer13/aw.jpg": 58562,
	"./images/projects/summer13/cc.jpg": 68256,
	"./images/projects/summer13/eg.jpg": 69702,
	"./images/projects/summer13/em.jpg": 76188,
	"./images/projects/summer13/fc.jpg": 41355,
	"./images/projects/summer13/gc.jpg": 67564,
	"./images/projects/summer13/hw.jpg": 11457,
	"./images/projects/summer13/kdb.jpg": 61681,
	"./images/projects/summer13/mf.jpg": 54395,
	"./images/projects/summer13/sbp.jpg": 76097,
	"./images/projects/summer13/ss.jpg": 60160,
	"./images/projects/summer13/tr.jpg": 98084,
	"./images/projects/summer14/3d_laser_scanner.webp": 44563,
	"./images/projects/summer14/CameraSurveillance.webp": 95871,
	"./images/projects/summer14/PET.webp": 87614,
	"./images/projects/summer14/auraplay.webp": 27924,
	"./images/projects/summer14/conway.webp": 35498,
	"./images/projects/summer14/fitness_sleep.webp": 2591,
	"./images/projects/summer14/fpga_music.jpg": 64565,
	"./images/projects/summer14/fpga_music.webp": 72327,
	"./images/projects/summer14/lasertag.webp": 81504,
	"./images/projects/summer15/SocialRobot.jpg": 50273,
	"./images/projects/summer15/SocialRobotp.jpg": 92957,
	"./images/projects/summer15/emg.jpg": 54163,
	"./images/projects/summer15/emgp.jpg": 9963,
	"./images/projects/summer15/fpga.jpg": 17018,
	"./images/projects/summer15/fpgap.jpg": 16184,
	"./images/projects/summer15/hand.jpg": 65971,
	"./images/projects/summer15/handp.jpg": 17195,
	"./images/projects/summer15/handshake.jpg": 73953,
	"./images/projects/summer15/handshakep.pdf": 45353,
	"./images/projects/summer15/lock.jpg": 72325,
	"./images/projects/summer15/lockp.jpg": 66601,
	"./images/projects/summer15/mood.jpg": 70985,
	"./images/projects/summer15/moodp.jpg": 99637,
	"./images/projects/summer16/hand.png": 84302,
	"./images/projects/summer16/kinects.jpg": 69140,
	"./images/projects/summer16/wifi.jpg": 24226,
	"./images/projects/summer17/bci.png": 12882,
	"./images/projects/summer17/hdmi.jpg": 45568,
	"./images/projects/summer17/stereo.png": 33566,
	"./images/projects/summer17/swarm.jpg": 17200,
	"./images/projects/summer18/1.jpg": 71254,
	"./images/projects/summer18/2.jpg": 57953,
	"./images/projects/summer18/3.jpg": 79908,
	"./images/projects/summer18/4.jpg": 4847,
	"./images/projects/summer18/5.png": 27510,
	"./images/projects/summer19/1.jpg": 36667,
	"./images/projects/summer19/2.jpg": 93868,
	"./images/projects/summer19/3.png": 49233,
	"./images/projects/summer19/4.png": 66142,
	"./images/projects/summer19/5.png": 18631,
	"./images/projects/summer19/6.png": 15980,
	"./images/projects/summer23/eeg.webp": 29282,
	"./images/projects/summer23/fieldingrobo.jpg": 83797,
	"./images/projects/summer23/maglev.jpg": 86711,
	"./images/projects/summer23/telepresence.jpg": 99542,
	"./images/projects/summer23/virtualclothing.png": 82068,
	"./images/projects/summer25/ANN.jpg": 28442,
	"./images/projects/summer25/Doodlebot.jpg": 60189,
	"./images/projects/summer25/enigma.jpg": 32544,
	"./images/projects/summer25/flexeglove.jpeg": 59611,
	"./images/projects/summer25/fpga.png": 96957,
	"./images/projects/summer25/virtualsinger.webp": 2076,
	"./images/takneek.jpg": 13376,
	"./images/techkriti.jpg": 39306,
	"./images/w logo.jpg": 36619,
	"./images/workshop.jpg": 8228,
	"./lectures/2017/Takneek'17 lecture.pdf": 62567,
	"./lectures/2017/lecture1.pdf": 44760,
	"./lectures/Analog.pdf": 81198,
	"./lectures/FPGA2017.pdf": 27882,
	"./lectures/Takneek 13/Verilog.pdf": 34476,
	"./lectures/Takneek 13/electromania.pdf": 41976,
	"./lectures/Techkriti 15/MCU.pdf": 9447,
	"./lectures/Techkriti 15/Techkriti15.pdf": 47061,
	"./lectures/Techkriti 16/Electromania-lecture.pdf": 99324,
	"./lectures/Techkriti 17/electromania17.pdf": 50218,
	"./lectures/Techkriti 17/embedded17.pdf": 6686,
	"./lectures/aad11/aad.pdf": 87549,
	"./lectures/aad11/secondActivity.java": 15364,
	"./lectures/embedded 13/Arduino.pdf": 26513,
	"./lectures/embedded 13/Communication.pdf": 79689,
	"./lectures/embedded 13/SkeletonBasics-WPF.zip": 5214,
	"./lectures/embedded 13/fpga.pdf": 9021,
	"./lectures/embedded 13/kinect_new.pdf": 46478,
	"./lectures/embedded/Embedded-New-1.pdf": 66282,
	"./lectures/embedded/Embedded-New-2.pdf": 98869,
	"./lectures/embedded/Embedded-New-3.pdf": 70112,
	"./lectures/embedded/Embedded-Old-1.pdf": 5603,
	"./lectures/embedded/Embedded-Old-2.pdf": 74188,
	"./lectures/embedded/Embedded-Old-3.pdf": 72881,
	"./lectures/embedded/Embedded-Old-4.pdf": 35994,
	"./lectures/embedded12/accelerometer.zip": 58972,
	"./lectures/embedded12/adc.pdf": 74086,
	"./lectures/embedded12/android.pdf": 25097,
	"./lectures/embedded12/communication.pdf": 40988,
	"./lectures/embedded12/kinect.pdf": 870,
	"./lectures/embedded14/IP.pdf": 56517,
	"./lectures/embedded14/arduino.pdf": 76350,
	"./lectures/embedded14/comm.pdf": 34294,
	"./lectures/embedded14/fpga.pdf": 64408,
	"./lectures/embedded14/kinect.pdf": 59576,
	"./lectures/embedded14/proc.pdf": 9826,
	"./lectures/fpga10/FPGAExamples.zip": 70482,
	"./lectures/fpga10/VerilogFPGA-1.pdf": 73744,
	"./lectures/fpga10/VerilogFPGA-2.pdf": 18807,
	"./lectures/summer 13/Microcontrollers.pdf": 74793,
	"./lectures/summer 13/Timers.pdf": 77528,
	"./lectures/summer 13/arduino.pdf": 86566,
	"./lectures/summer 13/ip_2.pdf": 74254,
	"./lectures/summer 13/opencv_sample.rar": 64795,
	"./lectures/summer12/adc.pdf": 5059,
	"./lectures/summer12/cvavr_and_avrstudio.pdf": 10205,
	"./lectures/summer12/introduction_to_mcu.pdf": 91409,
	"./lectures/summer12/opencv.pdf": 43100,
	"./lectures/summer12/spi.pdf": 61319,
	"./lectures/summer12/timers_and_interrupts.pdf": 50982,
	"./lectures/summer12/uart.pdf": 63143,
	"./lectures/summer14/MCU.pdf": 33478,
	"./lectures/summer14/analog.pdf": 3669,
	"./lectures/summer14/fpga_avi.pdf": 53736,
	"./lectures/summer14/img_process.pdf": 92660,
	"./lectures/summer14/rpi_lec.pdf": 9565,
	"./lectures/takneek 14/Introduction to FPGA_AVItakneek.pdf": 78226,
	"./lectures/takneek 14/lecture1.pdf": 70972,
	"./lectures/takneek 16/lecture1.pdf": 22326,
	"./lectures/takneek11/FpgaExamples2.rar": 89680,
	"./lectures/takneek11/Verilog1.pdf": 89445,
	"./lectures/takneek11/Verilog2.pdf": 57658,
	"./lectures/takneek11/bluetooth_datasheet.pdf": 49784,
	"./lectures/takneek11/bluetooth_lec.pdf": 75101,
	"./lectures/takneek11/embedded.m": 90979,
	"./lectures/takneek12/apptics.pdf": 54259,
	"./lectures/takneek12/electromania.pdf": 96561,
	"./lectures/takneek12/embedded.pdf": 80805,
	"./lectures/takneek12/fpga.pdf": 75053,
	"./lectures/techkriti12/ecdc_electromania.pdf": 15319,
	"./lectures/techkriti12/intro_mcu.pdf": 86081,
	"./lectures/techkriti12/lcd_and_interrupts.pdf": 79371,
	"./lectures/techkriti12/opencv.pdf": 27446,
	"./lectures/techkriti12/timers_and_interrupts.pdf": 23016,
	"./lectures/techkriti13/Introduction_to_mcu.pdf": 70746,
	"./lectures/techkriti13/Timers_and_Interrupts.pdf": 63733,
	"./lectures/techkriti13/fpga1.pdf": 31561,
	"./lectures/techkriti13/fpga2.pdf": 39486,
	"./lectures/techkriti14/FPGA Design Challenge1.pdf": 28827,
	"./lectures/techkriti14/FPGA Design Challenge2.pdf": 17028,
	"./lectures/techkriti14/MCU.pdf": 85612,
	"./lectures/techkriti14/Timers and Interrupts1.pdf": 29707,
	"./pdfs25/ANN.pdf": 30352,
	"./pdfs25/Doodlebot.pdf": 78351,
	"./pdfs25/Enigma.pdf": 4836,
	"./pdfs25/Image_Processing_in_FPGA.pdf": 751,
	"./pdfs25/flexeglove.pdf": 50282,
	"./pdfs25/groove.pdf": 98085,
	"./projects": 115,
	"./projects.json": 115,
	"./roadmapSteps": 7918,
	"./roadmapSteps.json": 7918,
	"./roadmaps": 21948,
	"./roadmaps.json": 21948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31858;